function colorValueToHex(c:number) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

export default function rgbToHex(r:number, g:number, b:number) {
    return "#" + colorValueToHex(r) + colorValueToHex(g) + colorValueToHex(b);
}